import {isExpoApp} from '../util.js';

class Live {

    constructor() {
        this.options = {};
        this.isConnecting = false;
        this.isActive = false;
        this.isActivePubSub = false;  // when server respond ok
        this.lastMessageId = null;
        this.lastMessagePid = null;
        this.ws = null;
        this.setupWebSocketTimer  = null;
        this.socketTimer  = null;

        this.channel2callbacks = {};
        this.channel2ids = {};

        this.observers = {};
    }

    log(/*message*/) {
        //console.log(new Date().hhmmss() + ': ' + message)
    }

    subscribeKey(key, option) {
        if(!option.callback) {return;}
        var list = this.observers[key];
        if(!list) {
            this.observers[key] = list = [];
        }
        list.push(option.callback);

        var unsubscribe = function() {
            var i = list.indexOf(option.callback);
            if(i>=0) {
                list.splice(i, 1);
            }
        };

        return unsubscribe;
    }

    publishKey(key, event) {
        var list = this.observers[key];
        if(!list) {return false;}
        for(var i=0;i<list.length;i++) {
            try {
                list[i](event.data[0], event);
            } catch (e) {
                console.error(e);
            }
        }
        return list.length > 0;
    }

    publishEvent(event) {
        var type = event.type || '';
        var action = event.action || '';
        this.publishKey(type + ':', event);
        this.publishKey(type + ':' + action, event);
    }
    
    subscribe(option) {
        option.type = option.type || '';
        option.action = option.action || '';
        return this.subscribeKey(option.type + ':' + option.action, {
            callback: option.callback
        });
    }

    channel2Broker(message) {
        if (this.channel2callbacks[message.key]) {
            this.channel2ids[message.key] = message.id;
            this.channel2callbacks[message.key].forEach((fn) => fn(message.data));
        }
    }

    channel2onWsOpen() {
        for (let key in this.channel2callbacks) {
            let lastId = this.channel2ids[key];
            this.ws.send(JSON.stringify({type: 'channel2', command: 'on', key: key, lastId: lastId}));
        }
    }
   
    subscribeChannel(key, fn) {
        let cancel = () => {
            if (this.ws && this.ws.readyState === 1) {
                this.ws.send(JSON.stringify({type: 'channel2', command: 'off', key: key}));
            }
            if (!this.channel2callbacks[key]) {
                return;
            }
            
            let i = this.channel2callbacks[key].indexOf(fn);
            if (i<0){
                return;
            }

            this.channel2callbacks[key].splice(i, 1);
            if (!this.channel2callbacks[key].length) {
                delete this.channel2callbacks[key];
                delete this.channel2ids[key];
            }
        };

        if (this.ws && this.ws.readyState === 1) {
            this.ws.send(JSON.stringify({type: 'channel2', command: 'on', key: key, lastId: 0}));
        }

        if (!this.channel2callbacks[key]) {
            this.channel2callbacks[key]=[];
        }
        this.channel2callbacks[key].push(fn);

        return cancel;
    }

    wsOpen() {
        this.log('Opened connection');
        this.isConnecting = false;
        this.isActive = true;
        //$rootScope.pubsub.publish('live.connect', true);
        this.channel2onWsOpen();

        this.$root.$store.commit('setIsConnected', true)
    }

    wsClose() {
        this.log('Connection closed');
        this.isConnecting = false;
        this.isActive = false;
        this.isActivePubSub = false;
        if (!this.setupWebSocketTimer) {
            this.setupWebSocketTimer = window.setTimeout(() => this.setupWebSocket(), 1000);
        }

        this.$root.$store.commit('setIsConnected', false)
    }

    wsError() {
        this.log('Error on websocket');
        this.isConnecting = false;
        this.isActive = false;
        this.isActivePubSub = false;
        if (!this.setupWebSocketTimer) {
            this.setupWebSocketTimer = window.setTimeout(() => this.setupWebSocket(), 1000);
        }

        this.$root.$store.commit('setIsConnected', false)
    }

    resetSocketTimer() {
        if (this.setupWebSocketTimer) {
            window.clearTimeout(this.setupWebSocketTimer);
        }
        if (this.socketTimer) {
            window.clearInterval(this.socketTimer);
        }
        this.socketTimer = window.setInterval( () => this.socketTimeout(), 10000);
    }

    socketTimeout() {
        this.setupWebSocket();
    }

    setupWebSocket() {
        if (this.setupWebSocketTimer) {
            window.clearTimeout(this.setupWebSocketTimer);
            this.setupWebSocketTimer = null;
        }
        if (this.isConnecting) {
            return;
        }

        this.log("Trying to connect...");
        if (this.ws) {
            this.ws.onerror = undefined;
            this.ws.onclose = undefined;
            this.ws.close();
        }

        this.isConnecting = true;
        this.isActive = false;
        this.isActivePubSub = false;
        var url = this.options.url;
        if (document.location.protocol == 'http:') {
            // not secure connection, change wss to ws
            url = url.replace(/^wss:/, 'ws:');
        }
        this.ws = new WebSocket(url);
        this.ws.onopen = () => this.wsOpen();
        this.ws.onclose = () => this.wsClose();
        this.ws.onerror = () => this.wsError();
        this.ws.onmessage = (event) => this.wsMessage(event);
        this.resetSocketTimer();
    }

    wsMessage(event) {
        this.resetSocketTimer();
        var message = JSON.parse(event.data);
        //var message = jsoncoder.decode(JSON.parse(event.data));

        if (message.type == 'ping') {
            return;
        }

        this.log('Got message of type ' + message.type + ' with id ' + message.id);

        // REMOVED IN IN-139: FIX FOR BUG-621
        // FIXME: Implement reloading in better way
        //        in the future.
        // if (message.type == 'reload') {
        //     if (!this.options.reload) {
        //         return;
        //     }
        //
        //     if(message.delay) {
        //         setTimeout(function() {
        //             window.location.reload();
        //         }, message.delay * 1000);
        //     } else {
        //         window.location.reload();
        //     }
        //     return;
        // }
        if (message.type == 'reload') {
            return;
        }

        if (message.type == 'last') {
            if (this.lastMessageId && (message.id > this.lastMessageId+10 || message.pid != this.lastMessagePid)) {
                // Reload - we lost connection
                if (this.options.reload) {
                    window.location.reload();
                }
                return;
            }
            if (!this.isActivePubSub) {
                this.isActivePubSub = true;
                //$rootScope.pubsub.publish('live.active', true); // Vuex websocket event
            }
        }

        if (message.type === 'channel2') {
            return this.channel2Broker(message);
        }

        this.publishEvent(message);

        this.lastMessageId = message.id;
        this.lastMessagePid = message.pid;

     /*   var numMessages = message.data ? message.data.length : 0;

        var options = { sendServerChangeEvent: true, runApply: false };

        for (var i=0; i < numMessages; ++i) {
            var messageData = message.data[i];

            live.options.handleMessage(message, messageData, options);
        }*/

/*        if (options.runApply) {
            $rootScope.$apply();
        }

        if (message.type == 'workout' && (message.action == 'remove' || message.action == 'add' || message.action == 'change')) {
            $rootScope.$broadcast('workoutsChanged');
        }

        if (options.sendServerChangeEvent) {
            $rootScope.$broadcast('serverChange', message);
        }*/
    }

   /* waitActive(timeout) {
        return $q.promise(function(resolve, reject) {
            var done = false;
            if(isActive) {
                resolve();
                return;
            }
            setupWebSocket();

            function liveActive() {
                $rootScope.pubsub.unsubscribe('live.active', liveActive);
                if(done) {return;}
                done = true;
                resolve();
            }
            $rootScope.pubsub('live.active', liveActive);

            if(timeout) {
                setTimeout(function() {
                    $rootScope.pubsub.unsubscribe('live.active', liveActive);
                    if(done) {return;}
                    done = true;
                    reject('timeout');
                }, timeout);
            }
        });
    };*/

    isActive() {
        return !!this.ws;
    }

    start(options) {
        this.options = options;
        this.$root = options.$root;
        this.setupWebSocket();
    }

    stop() {
        if (this.ws) {
            this.ws.onerror = undefined;
            this.ws.onclose = undefined;
            this.ws.close();
            if (this.setupWebSocketTimer) {
                window.clearTimeout(this.setupWebSocketTimer);
                this.setupWebSocketTimer = null;
            }
            if (this.socketTimer) {
                window.clearInterval(this.socketTimer);
                this.socketTimer = null;
            }
            this.ws = null;
            this.isConnecting = false;
            this.lastMessageId = undefined;
            this.lastMessagePid = undefined;
        }
    }

    sendToChannel(key, data) {
        this.ws.send(JSON.stringify({type: 'channel', key: key, data: data}));
    }

    authenticate(session, origin) {
        this.log(`Authenticating websocket (from ${origin})`);
        if (!this.isActive) {return;}
        this.ws.send(JSON.stringify({type: 'auth', data: session}));
        if(isExpoApp() && window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'session', data: session }));
        }
    }
}

export default Live;
